import { ProductSizeSelection } from '@/src/packages/components/pages/Product/ProductControls/ProductOptions/ProductSizeSelector';
import { Box } from '@/src/packages/components/ui/Box';
import { FetchProductVariantGridSchema, StockLevels } from '@bitmap/contracts';
import { useProductForm } from '@/src/packages/components/contexts/product-form.context';
import { z } from 'zod';
import Image from 'next/image';
import { ProductDescription } from '@/src/packages/components/pages/Product/ProductControls/ProductDescription';
import { Divider } from '@/src/packages/components/ui/Divider';
import { ProductMeta } from '@/src/packages/components/pages/Product/ProductControls';
import {
  Dialog,
  DialogClose,
  DialogOverlay,
} from '@/src/packages/components/ui/Dialog';
import { ProductAddToCartButton } from '@/src/packages/components/pages/Product/ProductControls/ProductAddToCartButton';
import { Button } from '@/src/packages/components/ui/Button';
import { DialogContent, DialogPortal } from '@radix-ui/react-dialog';

export const ProductCardInlineForm = ({
  isOpen,
  productVariant,
  handleClose,
}: {
  isOpen: boolean;
  handleClose(): void;
  productVariant: z.TypeOf<typeof FetchProductVariantGridSchema>;
}) => {
  const { handleSelectOption, selectedOptions, selectedSku } = useProductForm();

  const {
    product: { options },
    skus,
  } = productVariant;

  return (
    <Dialog open={isOpen} onOpenChange={handleClose}>
      <DialogPortal>
        <DialogOverlay>
          <DialogContent className="relative  w-[1000px] bg-white">
            <DialogClose className="right-0 top-0" />
            <Box className="flex">
              <Box className="flex-1">
                <Box className="relative aspect-square">
                  <Image
                    className="object-cover"
                    fill
                    alt=""
                    src={productVariant.images[0].fields.file.url}
                  />
                </Box>
              </Box>

              <Box className="flex-1">
                <Box className="p-12">
                  <ProductMeta
                    title={productVariant.product.title}
                    priceList={productVariant.product.priceList}
                    reviews={[]}
                  />
                  <Box className="space-y-2">
                    <ProductDescription
                      description={productVariant.product.description || ''}
                    />
                    <Divider borderColor="muted" />

                    {options.map((option) => {
                      return (
                        <ProductSizeSelection
                          key={option.id}
                          option={option}
                          handleSelectOption={handleSelectOption}
                          options={options}
                          selectedOptions={selectedOptions}
                          skus={skus}
                        />
                      );
                    })}

                    <Divider borderColor="muted" />

                    <ProductAddToCartButton
                      selectedSku={selectedSku}
                      priceList={productVariant.product.priceList}
                    />
                    <Button isBlock size="lg">
                      View full product page
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Box>
          </DialogContent>
        </DialogOverlay>
      </DialogPortal>
    </Dialog>
  );
};
